import { createRouter, createWebHashHistory } from 'vue-router'

import pinia from '@/store'
import { useAuthStore } from '@/store/auth'

import { routes } from './routes'

export const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

router.beforeEach((to, _, next) => {
  const auth = useAuthStore(pinia)
  const needsAuth =
    !['login', 'redirectLogin', 'supportLogin'].includes(to.name?.toString() || '') &&
    !['/login', '/redirect-login', '/support-login'].includes(to.path)
  const isAuthenticated = auth.isAuthenticated

  if (needsAuth && !isAuthenticated) {
    next({
      name: 'login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})
